import { makeAutoObservable } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import {
  type IParamsCreateBulkInboxPerNumber,
  type IResponseNumber,
} from 'entities/Phone/api/types'
import { NewInboxStore } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/store/newInboxStore'

export class NewInboxPerNumberStore {
  items
  constructor(private _entities: IEntitiesStore, _numbers: IResponseNumber[]) {
    this.items = _numbers.map((number) => {
      const newInboxStore = new NewInboxStore(this._entities)
      newInboxStore.setNewInboxName(number.number)
      if (this._entities.usersStore.user?.id) {
        newInboxStore.setActiveInboxOwner(this._entities.usersStore.user?.id)
      }

      return {
        newInboxStore,
        number,
      }
    })
    makeAutoObservable(this)
  }

  getParamsAircall = (rejectAssignedNumbers: number[]) => {
    const filteredTeams = this.items.filter(
      (item) => !rejectAssignedNumbers.includes(item.number.id)
    )

    const teams = filteredTeams.map((item) => ({
      name: item.newInboxStore.newInboxName,
      ownerId: item.newInboxStore.activeInboxOwner || 0,
      number_vendor_id: this._entities.complianceStore.aircallNumberVendorId,
      numbers: [
        {
          number: item.number.number,
          vendor_id: item.number.id.toString(),
        },
      ],
    }))

    return {
      teams,
    }
  }

  get params(): IParamsCreateBulkInboxPerNumber {
    return {
      teams: this.items.map((item) => ({
        name: item.newInboxStore.newInboxName,
        numberIds: [item.number.id],
        ownerId: item.newInboxStore.activeInboxOwner || 0,
      })),
    }
  }

  get nextDisabled() {
    return this.items.find((item) => item.newInboxStore.nextDisabled)
  }
}
